<template>
  <div class="main-container">
    <div class="main-container-title-box">
      <div class="main-container-title-box-text">
        <span class="title-box-text"> Список чатов </span>

        <v-icon
          @mouseover="openInfo($event)"
          @mouseleave="showInfo = false"
          color="var(--app-dark-blue-1)"
          >mdi-information</v-icon
        >
      </div>
      <div>
        <v-btn
          @click="goToAllChat"
          style="width: auto !important"
          class="button-action"
        >
          Читать все
        </v-btn>
        <v-btn
          v-if="userEditMod"
          @click="dialog = true"
          style="width: auto !important; margin-left: 40px"
          class="button-accept"
        >
          + Добавить тему
        </v-btn>
      </div>
    </div>

    <v-menu
      v-model="showInfo"
      :position-x="x"
      :position-y="y"
      absolute
      offset-y
    >
      <v-card min-width="300px" min-height="100px">
        <div class="menu-container">
          <div class="menu-container-title">«Темы»</div>
          <div class="menu-container-text">
            Настраеваемый список чатов. Возможность добавлять новые темы,
            закреплять чат в определенном порядке и модерировать его.
          </div>
          <div class="menu-container-title">
            Иконка
            <v-icon small color="#929292"> mdi-newspaper-variant </v-icon>
          </div>
          <div class="menu-container-text">
            Чат относящийся к определенной новости, можно только модерировать.
          </div>
          <div class="menu-container-title">
            Иконка
            <v-icon small color="#929292"> mdi-calendar-today </v-icon>
          </div>
          <div class="menu-container-text">
            Чат относящийся к определенному событию, можно только модерировать
          </div>
        </div>
      </v-card>
    </v-menu>

    <div class="main-container-tables">
      <v-tabs
        class="container-banners-tabs"
        color="var(--app-dark-blue-1)"
        v-model="tabNumber"
      >
        <v-tab> Темы </v-tab>
        <v-tab> Новости и события </v-tab>
        <v-tab-item class="tables-container">
          <div v-if="userEditMod" class="container-table-box">
            <v-data-table
              :headers="tableHeaders"
              :items="themeItems"
              hide-default-header
              item-key="id"
              fixed-header
              :footer-props="{
                itemsPerPageOptions: [10, 25, 50],
                'items-per-page-text': '',
              }"
              :items-per-page="optionTableThemes.itemsPerPage"
              :server-items-length="optionTableThemes.serverItemsLength"
              :page="optionTableThemes.page"
              @pagination="tableChangeThemes"
              class="elevation-0 rounded-0 container-table"
              :class="{ 'container-on-loading': true }"
              loading-text="Данные загружаются"
            >
              <template v-slot:header>
                <thead>
                  <tr>
                    <th></th>
                    <th>Порядок отображения</th>
                    <th>Иконка</th>
                    <th>Название</th>
                    <th>Новые сообщения</th>
                    <th></th>
                  </tr>
                </thead>
              </template>

              <template v-slot:body="props">
                <draggable
                  :list="props.items"
                  tag="tbody"
                  @end="endDrag"
                  :move="checkMove"
                  :style="moveItems ? 'pointer-events: none;' : ''"
                >
                  <tr
                    v-for="(item, index) in props.items"
                    :key="item.id"
                    :style="item.isPinned ? 'pointer-events: none;' : ''"
                  >
                    <td>
                      <v-icon
                        v-if="!item.isPinned"
                        small
                        style="cursor: pointer"
                        :disabled="moveItems ? true : false"
                      >
                        mdi-menu
                      </v-icon>
                    </td>
                    <td style="max-width: 100px !important">{{ index + 1 }}</td>
                    <td>
                      <v-img
                        style="height: 24px; width: 24px"
                        :src="item.image"
                      ></v-img>
                    </td>

                    <td>{{ item.title }}</td>
                    <td>
                      <span
                        v-if="item.countUnreadMessages > 0"
                        style="color: #1064dd"
                      >
                        {{ item.countUnreadMessages }}
                      </span>
                      <span v-else>
                        {{ item.countUnreadMessages }}
                      </span>
                    </td>

                    <td class="d-flex align-center justify-end">
                      <div
                        v-if="!item.isPinned"
                        @click="pinChat(item)"
                        style="cursor: pointer"
                      >
                        <v-icon> mdi-pin</v-icon>
                      </div>
                      <div
                        v-else
                        @click="pinChat(item)"
                        style="cursor: pointer"
                        :style="item.isPinned ? 'pointer-events: auto;' : ''"
                      >
                        <v-icon color="#1064DD"> mdi-pin</v-icon>
                      </div>
                      <div
                        :style="item.isPinned ? 'pointer-events: auto;' : ''"
                        style="margin: 0px 20px; cursor: pointer"
                        @click="openDialog(item)"
                      >
                        <v-icon>mdi-pencil-outline</v-icon>
                      </div>

                      <v-icon
                        @click="goToChat(item)"
                        :style="item.isPinned ? 'pointer-events: auto;' : ''"
                        >mdi-forum-outline</v-icon
                      >
                    </td>
                  </tr>
                </draggable>
              </template>
            </v-data-table>
          </div>
          <div v-else-if="!userEditMod" class="container-table-box">
            <v-data-table
              :headers="tableHeaders"
              :items="themeItems"
              item-key="id"
              :show-select="false"
              :footer-props="{
                itemsPerPageOptions: [10, 25, 50],
                'items-per-page-text': '',
              }"
              :items-per-page="optionTableThemes.itemsPerPage"
              :server-items-length="optionTableThemes.serverItemsLength"
              :page="optionTableThemes.page"
              @pagination="tableChangeThemes"
              class="elevation-0 rounded-0 container-table"
              :class="{ 'container-on-loading': true }"
              loading-text="Данные загружаются"
              fixed-header
            >
              <template v-slot:[`item.action`]="{ item }">
                <v-icon @click="goToChat(item)">mdi-forum-outline</v-icon>
              </template>
              <template v-slot:[`item.countUnreadMessages`]="{ item }">
                <td>
                  <span
                    v-if="item.countUnreadMessages > 0"
                    style="color: #1064dd"
                  >
                    {{ item.countUnreadMessages }}
                  </span>
                  <span v-else>
                    {{ item.countUnreadMessages }}
                  </span>
                </td>
              </template>
            </v-data-table>
          </div>
          <div class="void-items" v-else>
            <v-progress-circular
              indeterminate
              :width="4"
              :size="70"
              color="var(--app-dark-blue-1) "
            ></v-progress-circular>
          </div>
        </v-tab-item>
        <v-tab-item class="tables-container">
          <div class="container-table-box">
            <v-data-table
              :headers="tableHeaders"
              :items="newsEventsItems"
              item-key="id"
              :show-select="false"
              :footer-props="{
                itemsPerPageOptions: [10, 25, 50],
                'items-per-page-text': '',
              }"
              :items-per-page="optionTableNewsEvents.itemsPerPage"
              :page="optionTableNewsEvents.page"
              :server-items-length="optionTableNewsEvents.serverItemsLength"
              @pagination="tableChangeNewsEvents"
              class="elevation-0 rounded-0 container-table"
              :class="{ 'container-on-loading': true }"
              loading-text="Данные загружаются"
              fixed-header
            >
              <template v-slot:[`item.title`]="{ item }">
                <div class="d-flex">
                  <v-icon
                    v-if="item.folder == 'news'"
                    color="var(--app-dark-blue-1)"
                    >mdi-newspaper-variant</v-icon
                  >
                  <v-icon
                    v-else-if="item.folder == 'events'"
                    color="var(--app-dark-blue-1)"
                    >mdi-calendar-today</v-icon
                  >
                  <div style="margin-left: 16px">{{ item.title }}</div>
                </div>
              </template>
              <template v-slot:[`item.action`]="{ item }">
                <v-icon @click="goToChat(item)">mdi-forum-outline</v-icon>
              </template>
              <template v-slot:[`item.countUnreadMessages`]="{ item }">
                <td>
                  <span
                    v-if="item.countUnreadMessages > 0"
                    style="color: #1064dd"
                  >
                    {{ item.countUnreadMessages }}
                  </span>
                  <span v-else>
                    {{ item.countUnreadMessages }}
                  </span>
                </td>
              </template>
            </v-data-table>
          </div>
        </v-tab-item>
      </v-tabs>
    </div>
    <v-divider></v-divider>

    <v-dialog width="570px" height="auto" persistent v-model="dialog">
      <v-card width="570px" height="auto" class="rounded-0">
        <v-form ref="formFirst">
          <v-card-title class="dialog-title">
            <span v-if="selectedItem.id" class="title">Редактировать тему</span>
            <span v-else class="title">Добавить тему</span>
            <v-icon @click="closeDialog">mdi-close</v-icon>
          </v-card-title>
          <v-card-text class="dialog-description">
            <v-text-field
              style="margin-top: 20px"
              label="Название"
              required
              type="text"
              outlined
              :rules="rules"
              counter="100"
              maxlength="100"
              v-model="selectedItem.title"
            ></v-text-field>
            <v-file-input
              accept="image/jpeg, image/jpeg, image/png"
              outlined
              :rules="rules"
              persistent-hint
              @change="changeIcon"
              :label="
                selectedItem.id
                  ? 'Прикрепить новую иконку'
                  : 'Прикрепить иконку'
              "
            ></v-file-input>
          </v-card-text>
          <v-card-actions class="dialog-buttons">
            <v-btn
              style="width: 120px !important"
              @click="saveChat"
              class="button-accept"
            >
              Сохранить
            </v-btn>
            <v-btn
              v-if="selectedItem.id"
              @click="dialogDelete = true"
              outlined
              style="width: 120px !important"
              color="var(--app-red-1)"
              class="button-accept-outlined"
            >
              Удалить
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog width="600px" height="auto" persistent v-model="dialogDelete">
      <v-card>
        <v-card-title class="dialog-title">
          <span class="title">Точно хотите удалить чат?</span>
          <v-icon @click="dialogDelete = false">mdi-close</v-icon>
        </v-card-title>
        <v-card-actions class="dialog-buttons">
          <v-btn
            @click="dialogDelete = false"
            style="width: 120px"
            outlined
            color="var(--app-green-1)"
          >
            Нет
          </v-btn>
          <v-btn
            @click="deleteChat"
            style="width: 120px"
            outlined
            color="var(--app-red-1)"
          >
            Да
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import draggable from "vuedraggable";
export default {
  components: {
    draggable,
  },
  data: () => ({
    userEditMod: false,
    showInfo: false,
    x: null,
    y: null,
    dialog: false,
    moveItems: false,
    dialogDelete: false,
    selectedItem: {},
    selectedDrag: "",
    themeItems: [],
    newsEventsItems: [],
    useDebounce: null,
    optionTableThemes: {
      page: 1,
      itemsPerPage: 10,
      serverItemsLength: -1,
    },
    optionTableNewsEvents: {
      page: 1,
      itemsPerPage: 10,
      serverItemsLength: -1,
    },
    tabNumber: 0,
    rules: [(value) => !!value || "Обязательно к заполнению"],
    tableHeaders: [
      {
        text: "Название",
        sortable: false,
        value: "title",
      },
      {
        text: "Новые сообщения",
        value: "countUnreadMessages",
        sortable: false,
      },
      {
        text: "",
        align: "right",
        sortable: false,
        value: "action",
      },
    ],
    isLoading: false,
  }),
  methods: {
    closeDialog() {
      this.dialog = false;
      setTimeout(() => {
        this.$refs.formFirst.reset();
        this.selectedItem = {};
      }, 100);
    },
    openDialog(item) {
      this.selectedItem = Object.assign({}, item);

      this.dialog = true;
    },
    openInfo(e) {
      e.preventDefault();
      this.x = e.clientX + 10;
      this.y = e.clientY + 10;
      this.showInfo = true;
    },

    goToChat(item) {
      this.$router.push({ name: "Chat", params: { id: item.id } });
    },
    goToAllChat() {
      this.$router.push({ name: "Chat", params: { id: "all" } });
    },

    checkStorage() {
      const localTab = JSON.parse(localStorage.getItem("chatsTab"));
      if (localTab) {
        this.tabNumber = localTab;
        if (localTab > 0) {
          this.getItems(["news", "events"], localTab);
        } else {
          this.getItems(["themes"], localTab);
        }
      } else {
        this.getItems(["themes"], this.tabNumber);
      }
    },
    tableChangeThemes(data) {
      this.useDebounce(() => {
        this.optionTableThemes.page = data.page;
        this.optionTableThemes.itemsPerPage = data.itemsPerPage;
        this.getItems(["themes"], this.tabNumber);
      }, 300);
    },
    tableChangeNewsEvents(data) {
      this.useDebounce(() => {
        this.optionTableNewsEvents.page = data.page;
        this.optionTableNewsEvents.itemsPerPage = data.itemsPerPage;
        this.getItems(["news", "events"], this.tabNumber);
      }, 300);
    },
    getItems(item, tabNumber) {
      this.isLoading = true;
      const optionTables = ["optionTableThemes", "optionTableNewsEvents"];
      this.$axios
        .post(
          this.$store.getters.apiAdminPanelV7 + "/chat/list/for-admin",
          {
            optionTable: this[optionTables[tabNumber]],
            folders: item,
          },
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
              "secret-key": this.$store.state.secretKeyCookie,
            },
          }
        )
        .then((res) => {
          if (tabNumber === 0) {
            this.themeItems = res.data.items;
          }
          if (tabNumber === 1) {
            this.newsEventsItems = res.data.items;
          }
          this[optionTables[tabNumber]] = res.data.optionTable;
          this.isLoading = false;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    pinChat(item) {
      item.isPinned = !item.isPinned;
      let url = item.isPinned ? "/club/chat/pin" : "/club/chat/unpin";
      this.$axios
        .post(
          this.$store.getters.apiAdminPanelV2 + url,
          {
            chatId: item.id,
          },
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
            },
          }
        )
        .then(() => {
          this.checkStorage();
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    saveChat() {
      if (this.$refs.formFirst.validate()) {
        let formData = new FormData();
        if (this.selectedItem.id) {
          formData.append("chatId", this.selectedItem.id);
        }
        formData.append("title", this.selectedItem.title);
        formData.append("image", this.selectedItem.image);
        if (this.selectedItem.id) {
          this.$axios
            .put(this.$store.getters.apiAdminPanelV2 + "/club/chat", formData, {
              headers: {
                authorization: this.$store.getters.adminPanelHeaderAuth,
              },
            })
            .then(() => {
              setTimeout(() => {
                this.closeDialog();
                this.checkStorage();
              }, 1000);
            })
            .catch((err) => {
              this.$store.commit("errorSet", true);
              this.$store.commit("errorTextSet", err);
            });
        } else {
          this.$axios
            .post(
              this.$store.getters.apiAdminPanelV2 + "/club/chat",
              formData,
              {
                headers: {
                  authorization: this.$store.getters.adminPanelHeaderAuth,
                },
              }
            )
            .then(() => {
              setTimeout(() => {
                this.closeDialog();
                this.checkStorage();
              }, 1000);
            })
            .catch((err) => {
              this.$store.commit("errorSet", true);
              this.$store.commit("errorTextSet", err);
            });
        }
      }
    },

    deleteChat() {
      this.$axios
        .delete(this.$store.getters.apiAdminPanelV2 + "/club/chat", {
          headers: {
            authorization: this.$store.getters.adminPanelHeaderAuth,
          },
          params: {
            chatId: this.selectedItem.id,
          },
        })
        .then(() => {
          this.dialogDelete = false;
          this.closeDialog();
          this.checkStorage();
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    changeIcon(file) {
      this.selectedItem.image = file;
    },
    endDrag(evt) {
      this.moveItems = true;
      this.$axios
        .put(
          this.$store.getters.apiAdminPanelV2 + "/club/chat/sort",
          {
            chatId: this.selectedDrag,
            index: evt.newIndex + 1,
          },
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
            },
          }
        )
        .then(() => {
          this.checkStorage();
          this.moveItems = false;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    checkMove(evt) {
      this.selectedDrag = evt.draggedContext.element.id;
    },
    addMess(item) {
      if (item.data && item.data.chatId) {
        this.themeItems = this.themeItems.map((i) => {
          if (i.id == item.data.chatId) {
            i.countUnreadMessages = i.countUnreadMessages + 1;
            return i;
          } else {
            return i;
          }
        });
        this.newsEventsItems = this.newsEventsItems.map((i) => {
          if (i.id == item.data.chatId) {
            i.countUnreadMessages = i.countUnreadMessages + 1;
            return i;
          } else {
            return i;
          }
        });
      }
    },
    openSocket() {
      const token = this.$store.getters.adminPanelHeaderAuth;
      const wsChat = this.$store.getters.wsChatURL;

      let socket = new WebSocket(wsChat);
      socket.addMessage = this.addMess;

      this.connection = socket;
      socket.onopen = function () {
        socket.send(token);
      };
      socket.onmessage = function (event) {
        const item = JSON.parse(event.data);
        if (item.tag == "new_message") {
          socket.addMessage(item);
        }
      };
    },
  },
  created() {
    this.userEditMod = this.roleEditUser("shareholders_club");
    this.checkStorage();
    this.openSocket();
    this.useDebounce = this.createDebounce();
  },
  destroyed() {
    this.connection.close();
  },
  watch: {
    tabNumber() {
      localStorage.setItem("chatsTab", this.tabNumber);
    },
  },
};
</script>
<style lang="scss" scoped>
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > td:not(.v-data-table__mobile-row),
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > div
  > tr:not(:last-child)
  > th:not(.v-data-table__mobile-row) {
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}

.v-data-table > .v-data-table__wrapper > table > tbody > div > tr > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
  font-size: 0.875rem;
  height: 48px;
}
.container-table-box {
  min-height: 300px;
  height: calc(100vh - 242px) !important;
  overflow: auto;

  .container-on-loading {
    ::v-deep(.v-data-table__progress) {
      position: relative !important;
      height: 6px !important;
      visibility: visible !important;
    }

    ::v-deep(.v-data-table__progress) th {
      padding: 0 !important;
      overflow: hidden !important;
    }
  }

  .container-table {
    height: calc(100vh - 242px) !important;
    min-height: calc(100vh - 242px) !important;
    max-height: calc(100vh - 242px) !important;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
}
.v-tab {
  text-transform: none;
  font-size: 1rem;
  line-height: 1rem;
  letter-spacing: normal;
  font-weight: 400;
}

.main-container-tables {
  height: calc(100vh - 190px);

  .tables-container {
    height: calc(100vh - 238px);
    overflow: auto;

    .void-items {
      display: flex;
      align-items: center;
      justify-content: center;
      height: calc(100vh - 238px);
    }

    .main-table {
      height: calc(100vh - 238px) !important;
      min-height: calc(100vh - 238px) !important;
      max-height: calc(100vh - 238px) !important;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
  }
}
</style>
